<script>
import { mount, onMount } from "svelte";

import CodeCopyButton from "./CodeCopy.svelte";

onMount(() => {
  const preTags = document.getElementsByTagName("pre");

  for (let preTag of preTags) {
    const classList = Array.from(preTag.classList);

    const isCodeBlock = classList.some((className) => className.startsWith("shiki"));

    if (isCodeBlock) {
      const preTagParent = preTag.parentNode;

      const newCodeBlockWrapper = document.createElement("div");
      newCodeBlockWrapper.className = `code-block relative`;

      // new CodeCopyButton({
      //   target: newCodeBlockWrapper,
      // });

      mount(CodeCopyButton, {
        target: newCodeBlockWrapper,
      });

      preTag.className = `not-prose p-4 rounded-lg text-base leading-7 overflow-auto`;

      if (preTagParent) {
        preTagParent.replaceChild(newCodeBlockWrapper, preTag);
        newCodeBlockWrapper.appendChild(preTag);
      }
    }
  }
});
</script>

<!-- CodeInjector -->
<slot />
<!-- End CodeInjector  -->
